/* np-collection.js — behaviour for sections/new-collection.liquid.
   Cart adds go through the shared window.npCart API (assets/np-chrome.js). */
(function () {
  "use strict";
  var $ = function (id) { return document.getElementById(id); };

  /* Lipscore is the store's review platform; hydrate rating widgets.
     The theme's app embed usually loads it — this is a fallback. */
  if (!document.querySelector('script[src*="lipscore"]')) {
    window.lipscoreInit = function () { window.lipscore.init({ apiKey: "54b15725d0301f12251693f6" }); };
    var lsc = document.createElement("script");
    lsc.async = true;
    lsc.src = "https://static.lipscore.com/assets/en/lipscore-v1.js";
    document.head.appendChild(lsc);
  }

  /* ---- design filter state over server-rendered cards ---- */
  var SORTS = ["Featured", "Price ↑", "Price ↓", "Top rated"];
  var params = new URLSearchParams(window.location.search);
  var s = { cat: "All products", sort: 0, goal: params.get("goal") || null };

  var cards = [].slice.call(document.querySelectorAll("[data-item]"));
  var grid = $("nc-grid");

  function matches(c) {
    if (s.cat !== "All products" && c.dataset.cat !== s.cat) return false;
    if (s.goal) {
      var goals = (c.dataset.goals || "").split(",");
      if (goals.indexOf(s.goal) === -1) return false;
    }
    return true;
  }
  function apply() {
    var shown = cards.filter(matches);
    var sorted = shown.slice();
    if (s.sort === 1) sorted.sort(function (a, b) { return a.dataset.price - b.dataset.price; });
    else if (s.sort === 2) sorted.sort(function (a, b) { return b.dataset.price - a.dataset.price; });
    else if (s.sort === 3) sorted.sort(function (a, b) { return b.dataset.rating - a.dataset.rating; });
    else sorted.sort(function (a, b) { return a.dataset.idx - b.dataset.idx; });
    cards.forEach(function (c) { c.style.display = "none"; });
    sorted.forEach(function (c) { grid.appendChild(c); c.style.display = "flex"; });
    if ($("nc-count")) $("nc-count").textContent = shown.length + " product" + (shown.length === 1 ? "" : "s");
    if ($("nc-empty")) $("nc-empty").style.display = shown.length ? "none" : "block";
    updateControls();
  }

  function countFor(cat) {
    return cards.filter(function (c) { return (cat === "All products" || c.dataset.cat === cat) && (!s.goal || (c.dataset.goals || "").split(",").indexOf(s.goal) > -1); }).length;
  }

  /* Built once so a click never destroys the button the user just focused
     (keeps keyboard focus on filter/sort re-render instead of losing it to
     document.body when innerHTML was rebuilt every click). */
  var catButtons = [];
  var sortButtons = [];
  function buildControls() {
    /* Category rows are links written by new-collection.liquid (22 Oct 2026, so search engines can follow them to each
       category's collection). A plain click filters this page in place as before; a new-tab or modified click follows
       the link. */
    var cw = $("nc-cats");
    if (cw) {
      [].slice.call(cw.querySelectorAll("[data-cat-link]")).forEach(function (a) {
        var cat = a.getAttribute("data-cat-link");
        a.addEventListener("click", function (e) {
          if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          e.preventDefault();
          s.cat = cat; apply();
        });
        catButtons.push({ cat: cat, btn: a, countEl: a.querySelector(".nc-cat-count") });
      });
    }
    var sw = $("nc-sorts");
    if (sw) {
      SORTS.forEach(function (name, i) {
        var b = document.createElement("button");
        b.type = "button";
        b.textContent = name;
        b.setAttribute("aria-pressed", "false");
        b.addEventListener("click", function () { s.sort = i; apply(); });
        sw.appendChild(b);
        sortButtons.push({ index: i, btn: b });
      });
    }
    /* the chip row now has content: let the shared swipe hint measure it */
    if (window.npSwipe) window.npSwipe();
  }
  function updateControls() {
    catButtons.forEach(function (entry) {
      var on = s.cat === entry.cat;
      entry.btn.style.cssText = "display:flex;align-items:center;justify-content:space-between;gap:12px;width:100%;border:0;background:" + (on ? "#0B0B0B" : "none") + ";border-radius:10px;padding:11px 13px;font:600 13.5px/1.3 Inter,system-ui,sans-serif;color:" + (on ? "#FFDD0E" : "#0B0B0B") + ";cursor:pointer;text-align:left;text-decoration:none";
      if (on) entry.btn.setAttribute("aria-current", "true"); else entry.btn.removeAttribute("aria-current");
      entry.countEl.style.cssText = "font:500 10px/1 'Kode Mono',ui-monospace,monospace;opacity:.62;flex:none";
      var n = countFor(entry.cat);
      entry.countEl.textContent = n;
      /* no empty categories in the menu (15 Oct 2026, Louis Smith's review: Carb Powders listed five "0" rows);
         "All products" and the chosen category always stay */
      if (n === 0 && !on && entry.cat !== "All products") entry.btn.style.display = "none";
    });
    sortButtons.forEach(function (entry) {
      var on = s.sort === entry.index;
      entry.btn.style.cssText = "border:1px solid " + (on ? "#0B0B0B" : "rgba(11,11,11,.18)") + ";background:" + (on ? "#0B0B0B" : "none") + ";color:" + (on ? "#FFDD0E" : "#0B0B0B") + ";border-radius:100px;padding:9px 15px;font:600 12px/1 Inter,system-ui,sans-serif;cursor:pointer;white-space:nowrap";
      entry.btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  function clearAll() {
    s = { cat: "All products", sort: 0, goal: null };
    if (window.history && window.history.replaceState && params.has("goal")) {
      var url = new URL(window.location.href);
      url.searchParams.delete("goal");
      window.history.replaceState({}, "", url);
    }
    apply();
  }
  if ($("nc-clear2")) $("nc-clear2").addEventListener("click", clearAll);

  buildControls();
  apply();

  /* ---- add to cart ---- */
  document.querySelectorAll("[data-atc]").forEach(function (b) {
    b.addEventListener("click", function () {
      var items = [{ id: parseInt(b.dataset.atc, 10), quantity: 1 }];
      /* npCart announces failures in its toast; nothing else to do here */
      if (window.npCart) window.npCart.add(items, { button: b }).catch(function () {});
    });
  });

  /* ---- faq accordions (shared .npfaq-* classes, see np-base.css) ---- */
  var faqButtons = document.querySelectorAll("[data-acc]");
  faqButtons.forEach(function (btn) {
    btn.setAttribute("aria-expanded", "false");
    btn.addEventListener("click", function () {
      var open = btn.getAttribute("aria-expanded") === "true";
      faqButtons.forEach(function (b) {
        b.setAttribute("aria-expanded", "false");
        var bd = b.parentElement.querySelector(".npfaq-body");
        if (bd) bd.classList.remove("is-open");
      });
      if (!open) {
        btn.setAttribute("aria-expanded", "true");
        var body = btn.parentElement.querySelector(".npfaq-body");
        if (body) body.classList.add("is-open");
      }
    });
  });
})();
